import React, { useState, useEffect } from "react";
import { Dialog, Grid } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "../../components/SoftButton";
import ActivateModal from "./components/SetupModal/ActivateModal";
import RankModal from "./components/SetupModal/Rank";
import LevelModal from "./components/SetupModal/Level";
import TopKPIModal from "./components/SetupModal/TopKPI";
import PersonalGoalsModal from "./components/SetupModal/PersonalGoals";
import MyLevelModal from "./components/SetupModal/MyLevel";
import AdminBulletin from "./components/SetupModal/AdminBulletin";
import CompanyValues from "./components/SetupModal/CompanyValues";
import PlayerMemo from "./components/SetupModal/PlayerMemo";
import QuoteOfTheDay from "./components/SetupModal/QuoteOfTheDay";
import DashboardSetup from "./components/SetupModal/Dashboard";
import DashboardTile from "./components/DashboardTile";
import QuoteOfTheDayEdit from "./components/EditModal/QuoteOfTheDayEdit";
import PersonalGoalEdit from "./components/EditModal/PersonalGoalEdit";
import CompanyValuesEdit from "./components/EditModal/CompanyValuesEdit";
import AdminBulletinEdit from "./components/EditModal/AdminBulletinEdit";
import EditModal from "./components/EditModal/EditModal";
import { refetchUserData } from "../../redux/auth/actions";
import {
  UseCompanyId,
  UseIsAdmin,
  UseUserDetails,
  UseUserId,
} from "../../hooks/auth";
import {
  DELETE_WIDGET_FROM_LIST,
  TOGGLE_OFF_WIDGET,
  TOGGLE_ON_WIDGET,
  GET_WIDGETS_LIST
} from "../../api/userWidgets";

import topKPI from "../../img/widgets/topkpi.png";
import adminBulletin from "../../img/widgets/admin.png";
import companyValues from "../../img/widgets/company.png";
import level from "../../img/widgets/level.png";
import personalGoals from "../../img/widgets/personalgoals.png";
import playersMemo from "../../img/widgets/bonus.png";
import ranking from "../../img/widgets/ranking.png";
import { GET_USER_BY_GROUPID } from "../../api/user";

import SoftDialog from "../../components/SoftConfirmationDialog";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckIcon from "@mui/icons-material/Check";

export const Components = {
  ranking: RankModal,
  level: LevelModal,
  my_level: MyLevelModal,
  top_kpi: TopKPIModal,
  personal_goals: PersonalGoalsModal,
  admin_bulletin: AdminBulletin,
  company_values: CompanyValues,
  player_memo: PlayerMemo,
  quote_of_the_day: QuoteOfTheDay,
  dashboard_link: DashboardSetup,
};

/* The Dashboard widget is the one card whose "Activate" is really "pick
   which boards", so re-opening the same modal is how you change the
   selection — and "Deactivate" has to clear every pinned board, not just
   the first one the user happens to have. */
export const DASHBOARD_WIDGET_KEY = "dashboard_link";

export const EditComponents = {
  personal_goals: PersonalGoalEdit,
  admin_bulletin: AdminBulletinEdit,
  company_values: CompanyValuesEdit,
  player_memo: PlayerMemo,
  my_level: MyLevelModal,
  quote_of_the_day: QuoteOfTheDayEdit,
};

const widgetsByAdmin = {
  admin_bulletin: "admin_bulletin",
  company_values: "company_values",
  player_memo: "player_memo",
  quote_of_the_day: "quote_of_the_day",
};

const WidgetBox = ({ widget, setReFetch, widgetTitle, widgetMetrics }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [buttonLabel, setButtonLabel] = useState(
    widget.toggled ? "Deactivate" : "Activate",
  );
  const [widgetStatus, setwidgetStatus] = useState(
    widget.toggled ? "Activated" : "Inactive",
  );

  const widgetIcon = {
    'Admin Bulletin': adminBulletin,
    'Company Values': companyValues,
    'Level': level,
    'My Level': level,
    'Personal Goals': personalGoals,
    'Bonus Estimate': playersMemo,
    'Ranking': ranking,
    'Top KPI': topKPI
  }[widget.title];

  /* The Dashboard card's button reopens the board picker rather than
     toggling, so once anything is pinned it reads as "change the choice". */
  let dashboardButtonLabel = "";
  if (widget.key === DASHBOARD_WIDGET_KEY) {
    dashboardButtonLabel = widget.toggled ? "Choose dashboards" : "Activate";
  }

  const open = Boolean(anchorEl);
  const Component = Components[widget.key];
  const EditComponent = EditComponents[widget.key];

  const userDetails = UseUserDetails();
  const userId = UseUserId();
  const isAdmin = UseIsAdmin();
  const companyId = UseCompanyId();
  const groupId = userDetails?.groupId;
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openModal = () => setModal(true);

  const closeModal = () => { setModal(false); };

  const openEditModal = () => setEditModal(true);

  const closeEditModal = () => setEditModal(false);

  const [deleteDialog, setdeleteDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [pendingDeletionUserId, setPendingDeletionUserId] = useState(null);
  const deleteModal = (userToDeleteId) => {
    setUserToDelete(userToDeleteId);
    setPendingDeletionUserId(userToDeleteId);
    setdeleteDialog(true);
  };
  const closedeleteModal = () => {
    setdeleteDialog(false);
    setUserToDelete(null);
    setDeleteStatus(false);
    setPendingDeletionUserId(null);
  };
  const confirmDelete = async () => {
    setdeleteDialog(false);
    
    // If there's a pending deletion user ID, handle deletion directly in WidgetBox
    // This happens when the widget modal was closed before opening Delete Modal
    if (pendingDeletionUserId) {
      try {
        // Fetch fresh widget data to ensure we have the latest
        const result = await GET_WIDGETS_LIST({
          key: widget.key,
          companyId: null,
          userId: null,
        });
        const widgetToRemove = result.data.find(
          (item) => item.userId === pendingDeletionUserId && item.key === widget.key,
        );
        if (widgetToRemove) {
          await DELETE_WIDGET_FROM_LIST(widgetToRemove._id, pendingDeletionUserId);
          dispatch(refetchUserData(userId));
          // Check if there are remaining users after deletion
          const remainingResult = await GET_WIDGETS_LIST({
            key: widget.key,
            companyId: null,
            userId: null,
          });
          const hasRemainingUsers = remainingResult.data.length > 0;
          setTimeout(() => {
            toast.success(hasRemainingUsers ? "Widget updated successfully" : "Widget deactivated successfully");
            setReFetch(2);
          }, 1000);
        }
        setPendingDeletionUserId(null);
        setDeleteStatus(false);
        setUserToDelete(null);
      } catch (error) {
        console.log("Error while deactivating the widget", error);
        setPendingDeletionUserId(null);
        setDeleteStatus(false);
        setUserToDelete(null);
      }
    } else {
      // If edit modal is still open, let PlayerMemo handle deletion via useEffect
      setDeleteStatus(true);
    }
  };
  const resetDeleteStatus = () => {
    setDeleteStatus(false);
    setUserToDelete(null);
    setPendingDeletionUserId(null);
  };
  const handleUsersMarkedForDeletion = (userIds) => {
    // This callback is called before closing the modal
    // The deletion will be handled after Delete Modal confirmation
  };

  const [updateDialog, setupdateDialog] = useState(false);
  const closeupdateDialog = () => {
    setupdateDialog(false);
    setReFetch(1);
  };
  const isUpdated = () => setupdateDialog(true);

  const [groupUsers, setGroupUsers] = useState([]);
  const [groupWidgets, setGroupWidgets] = useState([]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await GET_USER_BY_GROUPID(groupId);
        const result = await GET_WIDGETS_LIST({
          key: widget.key,
          companyId: null,
          userId: null,
        });
        setGroupUsers(data);
        setGroupWidgets(result.data);
      } catch (error) {
        console.error("Error fetching group users and widgets:", error);
      }
    };

    if (groupId && widget?.key) {
      fetchData();
    }
  }, [groupId, widget?.key, userId]);

  const getGroupUsersAndWidgets = () => {
    return { users: groupUsers, widgets: groupWidgets };
  };

  const triggerRemove = async () => {
    const { users, widgets } = await getGroupUsersAndWidgets();

    const filteredUsers = users.filter(
      (user) =>
        user._id !== userId &&
        !user.isArchived &&
        user.companyId !== null &&
        user.logins > 0
    );

    if (widgets.length) {
      const deletePromises = filteredUsers.map((user) => {
        const isUserExist = widgets.find((item) => item.userId === user._id);

        if (isUserExist) {
          return DELETE_WIDGET_FROM_LIST(isUserExist._id, isUserExist.userId);
        }
        return null;
      });

      Promise.all(deletePromises).then(() => {
        setTimeout(() => {
          toast.success("Widget deactivated successfully");
          setReFetch(2);
        }, 1000);
      });
    }
  };

  const triggerHandler = async () => {

    /* Pinned boards are several cards under one catalogue entry, so the
       button reopens the picker instead of toggling: that is where boards
       are both added and removed, and it is also how an admin reaches
       another player's pins. */
    if (widget.key === DASHBOARD_WIDGET_KEY) {
      openModal(true);
      return;
    }

    if (widget.toggled || buttonLabel !== "Activate") {
      const widgetToRemove = userDetails.widgets.find(
        (item) => item.key === widget.key,
      );

      try {
        if (widgetsByAdmin[widget.key] && !isAdmin && !userDetails.isAdmin) {
          await TOGGLE_OFF_WIDGET(widgetToRemove._id, userId);
        } else {
          await DELETE_WIDGET_FROM_LIST(widgetToRemove._id, userId);
        }

        dispatch(refetchUserData(userId));
        setTimeout(() => {
          setButtonLabel("Activate");
          setwidgetStatus("Inactive");
          toast.success("Widget deactivated successfully");
          setReFetch(1);
        }, 1000);
      } catch (error) {
        console.log("Error while deactivating the widget", error);
      }
    } else {

      if (widgetsByAdmin[widget.key] && !isAdmin && !userDetails.isAdmin) {
        try {
          const payload = {
            userId,
            companyId,
            key: widget.key,
          };

          await TOGGLE_ON_WIDGET(payload);
          dispatch(refetchUserData(userId));
          setTimeout(() => {
            setButtonLabel("Deactivate");
            setwidgetStatus("Actived");
            if(widgetStatus === "Activated"){
              setupdateDialog(true);
              toast.success("Widget updated successfully");
            }else{
              toast.success("Widget activated successfully");
            }
            setReFetch(1);
          }, 1000);
        } catch (error) {
          console.log("Error while calling TOGGLE_ON_WIDGET", error.response);
          toast.error(
            error.response?.data?.error?.message || "Something went wrong!",
          );
        }
        return;
      }
      openModal(true);
    }
  };

  return (
    <>
      {updateDialog && (
        <SoftDialog
          open={updateDialog}
          onClose={closeupdateDialog}
          title="Widget Updated "
          type="success"
          icon={<CheckIcon fontSize="large" sx={{ color: "#299E47" }} />}
          description={
            <SoftBox display="flex" justifyContent="center" mt="25px" mb="35px">
              <SoftTypography
                variant="p"
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#FFF",
                  textAlign: "center",
                }}
              >
                You have updated the Bonus Estimate Widget.<br/>
                Players can see their Bonus Estimate now.
              </SoftTypography>
            </SoftBox>
          }
          footer={
            <SoftBox display="flex" gap="10px" justifyContent="center">
              <SoftButton
                size="small"
                color="white"
                onClick={() => { closeupdateDialog(); }}
                sx={{
                  borderRadius: "4px",
                  width: "50%",
                  mt: 2,
                  mb: 2,
                  textTransform: "none",
                  color: "#344054",
                }}
              >
                Okay
              </SoftButton>
            </SoftBox>
          }
        />
      )}
	    {deleteDialog && (
        <SoftDialog
          open={deleteDialog}
          onClose={closedeleteModal}
          title="Remove Player?"
          type="error"
          icon={<WarningAmberIcon fontSize="large" sx={{ color: "#981B14" }} />}
          description={
            <SoftBox display="flex" justifyContent="center" mt="25px" mb="35px">
              <SoftTypography
                variant="p"
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#FFF",
                  textAlign: "center",
                }}
              >
                Are you sure you want to remove Player(s)<br/> from this widget?<br/>This action will unassign them and remove<br/> all related data.
              </SoftTypography>
            </SoftBox>
          }
          footer={
            <SoftBox
              display="flex"
              gap="1rem"
              justifyContent="center"
              alignItems="center"
              mt={3}
              mb={3}
              sx={{
                width: "100%",
                flex: 1,
                flexGrow: 1,
              }}
            >
              <SoftButton
                size="small"
                color="white"
                onClick={() => { closedeleteModal(); }}
                sx={{
                  flex: 1,
                  borderRadius: "4px",
                  textTransform: "none",
                  color: "#FFFFFF",
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "0.685293px solid rgba(233, 236, 239, 0.1)",
                  boxShadow: "0px 0.685293px 1.37059px rgba(0, 0, 0, 0.05)",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.1)",
                  },
                  width: "100%",
                }}
              >
                Cancel
              </SoftButton>
              <SoftButton
                size="small"
                color="white"
                onClick={confirmDelete}
                sx={{
                  flex: 1,
                  borderRadius: "4px",
                  textTransform: "none",
                  color: "#344054",
                  width: "100%",
                }}
              >
                Proceed
              </SoftButton>
            </SoftBox>
          }
        />
      )}
      <Dialog
        open={modal}
        onClose={closeModal}
        sx={{
          ".MuiPaper-root": {
            padding: { mini: "1rem", md: "1rem 1.5rem" },
            width: "100%",
            maxWidth: "600px",
            // glass
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)",
            border: "1px solid rgba(255,255,255,0.6)",
            boxShadow:
              "0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)",
            backdropFilter: "blur(18px) saturate(160%)",
            borderRadius: "24px",
            overflow: "visible",
          },
        }}
      >
        <ActivateModal closeModal={closeModal}>
          <Component
            widget={widget}
            closeModal={closeModal}
            setButtonLabel={setButtonLabel}
            isUpdated={isUpdated}
            widgetStatus={widgetStatus}
            setReFetch={setReFetch}
          />
        </ActivateModal>
      </Dialog>
      <Dialog
        open={editModal}
        onClose={closeEditModal}
        sx={{
          ".MuiPaper-root": {
            padding: { mini: "1rem", md: "1rem 1.5rem" },
            borderRadius: "24px",
            // glass
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)",
            boxShadow:
              "0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)",
            backdropFilter: "blur(18px) saturate(160%)",
            width: "100%",
            maxWidth: "600px",
            border: "1px solid rgba(255,255,255,0.6)",
          },
        }}
      >
        <EditModal closeModal={closeEditModal}>
          <EditComponent
            widget={widget}
            closeModal={closeEditModal}
            setButtonLabel={setButtonLabel}
            widgetStatus={widgetStatus}
            isUpdated={isUpdated}
            deleteModal={deleteModal}
            deleteStatus={deleteStatus}
            memberId={userToDelete}
            resetDeleteStatus={resetDeleteStatus}
            setReFetch={setReFetch}
            onUsersMarkedForDeletion={handleUsersMarkedForDeletion}
          />
        </EditModal>
      </Dialog>
        <SoftBox
          sx={{
            borderRadius: "16px",
            background: "#F3F7FA",
            marginBottom: "20px !important",
            backdropFilter: "blur(15px)",
            backgroundBlendMode: "overlay, normal",
            border: "1px solid #EAECF0",
          }}
        >
        <SoftBox container style={{padding: "14px"}}>
          <SoftBox
            sx={{
              borderRadius: "16px",
              backdropFilter: "blur(15px)",
              backgroundBlendMode: "overlay, normal",
              background: `linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0.39%, rgba(255, 255, 255, 0) 100.39%), radial-gradient(77.42% 100% at 50% 0.39%, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.09) 17.75%), linear-gradient(0deg, #FFFFFF, #FFFFFF);`,
              padding: 1,
              minHeight: "78px",
            }}
          >
            <SoftBox sx={{ paddingLeft: "10px" }}>
              <SoftTypography variant="body2">{widget.title}</SoftTypography>
              <SoftTypography
                variant="h4"
                sx={{
                  fontSize:
                    widget.key === "company_values" ||
                    widget.key === "personal_goals" ||
                    widget.key === "admin_bulletin"
                      ? "18px"
                      : undefined,
                  bottom:
                    widget.key === "company_values" ||
                    widget.key === "personal_goals" ||
                    widget.key === "admin_bulletin"
                      ? "0"
                      : undefined,
                  color: "#343A40",
                  fontWeight: 500,
                }}
              >
                {(() => {
                  // Check for "true" or boolean true
                  if (
                    widgetMetrics === true ||
                    (typeof widgetMetrics === "string" &&
                      widgetMetrics.trim().toLowerCase() === "true")
                  ) {
                    return ""; // not valid, show nothing
                  }
                  const value = String(widgetMetrics);
                  if (
                    (widget.key === "company_values" ||
                      widget.key === "personal_goals" ||
                      widget.key === "admin_bulletin") &&
                    value.length > 4
                  ) {
                    const truncated =
                      value.length > 60 ? value.substring(0, 60) + "..." : value;
                    return `${truncated}`;
                  } else {
                    return widgetMetrics;
                  }
                })()}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            borderBottomLeftRadius: "16px",
            borderBottomRightRadius: "16px",
            backdropFilter: "blur(15px)",
            backgroundBlendMode: "overlay, normal",
            background: `linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0.39%, rgba(255, 255, 255, 0) 100.39%), radial-gradient(77.42% 100% at 50% 0.39%, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.09) 17.75%), linear-gradient(0deg, #FFFFFF, #FFFFFF);`,
          }}
        >
          <Grid container style={{padding: "14px"}}>
            <Grid item mini={2}>
               {widget.key === DASHBOARD_WIDGET_KEY
                 ? <DashboardTile size={48} />
                 : <img src={widgetIcon} alt={widgetTitle} style={{marginTop: "0.5rem"}} />}
            </Grid>
            <Grid item mini={10}>
              <SoftBox
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <SoftBox display="flex" flexDirection="column" sx={{minHeight: "80px", paddingLeft: "1rem"}}>
                  <SoftTypography
                    sx={{ fontSize: "16px", fontWeight: "500", color: "#000" }}
                  >
                    {widgetTitle}
                  </SoftTypography>
                  <SoftTypography sx={{ fontSize: "12px", color: "#6C757D", marginBottom: !widget?.description ? "2rem" : 0 }}>
                    {widget?.description}
                  </SoftTypography>
                </SoftBox>
                {widget.editable && buttonLabel !== "Activate" && widgetTitle !== "Quote of the Day" && widgetTitle !== "Quote of the Day" && (
                  <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? "long-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="true"
                    disabled={(widgetTitle === 'Admin Bulletin' || widgetTitle === 'Bonus Estimate' || widgetTitle === 'My Level') && !isAdmin}
                    onClick={handleClick}
                  >
                    <MoreVertIcon />
                  </IconButton>
                )}
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={openEditModal}>
                    <SettingsIcon fontSize="small" mr={2} />
                    Edit Widget
                  </MenuItem>
                </Menu>
              </SoftBox>
            </Grid>
          </Grid>
          <SoftBox
            display="flex"
            justifyContent="center"
            pb={2}
            alignItems="center"
          >
          {(widgetTitle === "Bonus Estimate" || widgetTitle === "My Level") ? (
            <SoftButton
              color="primary"
              size="small"
              sx={{
                textAlign: 'center',
                background: "#FFFFFF",
                border: "1px solid #EAECF0;",
                borderRadius: "4px",
                textTransform: "capitalize",
                color: "#1D2939",
              }}
              onClick={widget.toggled ? triggerRemove : triggerHandler}
            >
              {widget.toggled ? "Deactivate" : "Activate"}
            </SoftButton>
          ) : (
            <SoftButton
              color="primary"
              size="small"
              disabled={(widgetTitle === 'Admin Bulletin' || widgetTitle === 'Bonus Estimate' || widgetTitle === 'My Level') && !isAdmin}
              sx={{
                textAlign: 'center',
                background: "#FFFFFF",
                border: "1px solid #EAECF0;",
                borderRadius: "4px",
                textTransform: "capitalize",
                color: "#1D2939",
              }}
              onClick={triggerHandler}
            >
              {dashboardButtonLabel || buttonLabel}
            </SoftButton>
          )}
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </>
  );
};

export default WidgetBox;
